import { render, staticRenderFns } from "./CustomersDownload.vue?vue&type=template&id=2e7810e2"
import script from "./CustomersDownload.vue?vue&type=script&lang=js"
export * from "./CustomersDownload.vue?vue&type=script&lang=js"
import style0 from "./CustomersDownload.vue?vue&type=style&index=0&id=2e7810e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports